<template>
  <div class="user-dialog">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" append-to-body :close-on-click-modal="false"
      :show-close="true" @closed="handleClose">
      <el-form ref="form" :model="form" label-position="top" :rules="rules" label-width="80px">
        <el-form-item label="" prop="value">
          <div class="slot-content">
            <div class="content-item" v-for="(item, index) in userList" :key="index">
              <div :class="['role-item', { selected: selectedUser === item.selectId }]" @click="selectUser(item)">
                {{ item.nickName + '(' + item.userName + ')' }}
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">{{ confirmText }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UserSelectDialog',
  props: {
    title: {
      type: String,
      default: '请选择登录用户'
    },
    confirmText: {
      type: String,
      default: '确 定'
    },
    visible: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {
        value: ''
      },
      rules: {
        value: [
          { required: true, message: '请选择用户', trigger: 'change' }
        ]
      },
      selectedUser: null
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    selectUser(item) {
      this.selectedUser = item.selectId
      this.form.value = item.selectId
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const selected = this.userList.find(user => user.selectId === this.selectedUser)
          this.$emit('submit', selected)
          this.dialogVisible = false
        }
      })
    },
    handleClose() {
      this.selectedUser = null
      this.form.value = ''
      this.$refs.form.resetFields()
      this.$emit('closed')
    }
  }
}
</script>

<style scoped lang="scss">
.user-dialog {
  ::v-deep .el-dialog__body {
    padding: 0;
  }
}
.slot-content {
  padding: 0 25px;
  max-height: 300px;
  overflow-y: auto;
}

.content-item {
  flex: 0 0 auto;
}

.role-item {
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #F3F8FF;
  background-color: #F3F8FF;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
}

.role-item:hover {
  background-color: #e5f2ff;
}

.role-item.selected {
  background-color: #076BF2;
  color: white;
  font-weight: bold;
  border: 1px solid #076BF2;
}

.dialog-footer {
  text-align: right;
}
</style>